import {projectCurrent} from "./endpoints";
import axiosClient from "./api";

const axiosClientJSON = axiosClient()
// const axiosClientForm = axiosClient('multipart/form-data')


const saveStaffAPI = async (id, data) => {
    return await axiosClientJSON.patch(projectCurrent.getStaff(id), data);
}

const saveEventsAPI = async (id, data) => {
    return await axiosClientJSON.post(projectCurrent.getEvents(id), data);
}

const getStaffAPI = async (id) => {
    return await axiosClientJSON.get(projectCurrent.getStaff(id));
}

const convertToCurrentProjectAPI = async (projectID) => {
    return await axiosClientJSON.post(projectCurrent.convertToCurrentProject(projectID));
};

const projectsCurrentListAPI = async () => {
    return await axiosClientJSON.get(projectCurrent.projectCurrentList);
}

const getEventsDataSetAPI = async (projectID) => {
    return await axiosClientJSON.get(projectCurrent.eventsDataSet(projectID));
}

const getDirectionDataAPI = async (projectID) => {
    return await axiosClientJSON.get(projectCurrent.directionDataSet(projectID));
}

const saveTechnicalInfoAPI = async (projectID, dataset) => {
    return await axiosClientJSON.post(projectCurrent.technicalInfoSave(projectID), dataset);
}

const projectsCurrentDetailsAPI = async (projectID) => {
    return await axiosClientJSON.get(projectCurrent.projectCurrentDetails(projectID));
}

const lineupGetDataAPI = async (projectID) => {
    return await axiosClientJSON.get(projectCurrent.lineupData(projectID));
}

const saveLineupAPI = async (projectID, dataset) => {
    return await axiosClientJSON.post(projectCurrent.lineupData(projectID), dataset);
}

const lineupViewDataAPI = async (projectID) => {
    return await axiosClientJSON.get(projectCurrent.lineupViewData(projectID));
}


export {
    getStaffAPI,
    saveStaffAPI,
    convertToCurrentProjectAPI,
    projectsCurrentListAPI,
    getEventsDataSetAPI,
    saveEventsAPI,
    getDirectionDataAPI,
    saveTechnicalInfoAPI,
    projectsCurrentDetailsAPI,
    lineupGetDataAPI,
    saveLineupAPI,
    lineupViewDataAPI,
};
